module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_7016.1ff1bcfa.png";